import { apiClient, type Paginated } from '@/core/api';
import { resolveContentType, type ContentTypeRef } from '@/features/comments/api';
import type {
  CustomFieldDef,
  CustomFieldDefInput,
  CustomFieldValue,
  CustomFieldValueUpsertInput,
} from './types';

const DEFS = '/collab/custom-field-defs/';
const VALUES = '/collab/custom-field-values/';

export { resolveContentType };
export type { ContentTypeRef };

function unwrap<T>(data: Paginated<T> | T[]): T[] {
  return Array.isArray(data) ? data : data.results;
}

// ---- Defs ----

export async function listDefs(entity: string): Promise<CustomFieldDef[]> {
  const { data } = await apiClient.get<Paginated<CustomFieldDef> | CustomFieldDef[]>(
    DEFS, { params: { entity } },
  );
  return unwrap(data);
}

export async function createDef(input: CustomFieldDefInput): Promise<CustomFieldDef> {
  const { data } = await apiClient.post<CustomFieldDef>(DEFS, input);
  return data;
}

export async function deleteDef(id: number): Promise<void> {
  await apiClient.delete(`${DEFS}${id}/`);
}

// ---- Values ----

export async function listValuesForTarget(
  entity: string, entityId: string | number,
): Promise<CustomFieldValue[]> {
  const { data } = await apiClient.get<Paginated<CustomFieldValue> | CustomFieldValue[]>(
    VALUES, { params: { entity, entity_id: entityId } },
  );
  return unwrap(data);
}

/** POST is upsert on the BE — (definition, content_type, object_id) is the key. */
export async function upsertValue(input: CustomFieldValueUpsertInput): Promise<CustomFieldValue> {
  const { data } = await apiClient.post<CustomFieldValue>(VALUES, input);
  return data;
}
